import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Select from "react-select";
import Ckeditor from '../../formatos/Formats/Ckeditor'

class FormCreate extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    show = (value) => {
        return this.props.title == "Agregar Subnumeral" ? "block" : "none"
    }

    render() {
        const { formValues, errorValues } = this.props;
        const isError = errorValues == false;

        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered rk-modal"
                backdrop={this.props.backdrop}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-list-ul"></i></span>
                    <h5>{this.props.title}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <div className="rk-modal__body">
                        <div className="row">

                            <div className="col-md-6" style={{ display: this.show() }}>
                                <div className="rk-field">
                                    <label className="rk-label">Título</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formValues.name}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.name == "" ? "rk-input--error" : ""}`}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Seguridad del paciente</label>
                                    <input
                                        type="text"
                                        name="patient_safety_standar"
                                        value={formValues.patient_safety_standar}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.patient_safety_standar == "" ? "rk-input--error" : ""}`}
                                        placeholder="Seguridad del paciente"
                                    />
                                </div>
                            </div>

                            <div className="col-md-6" style={{ display: this.show() }}>
                                <div className="rk-field">
                                    <label className="rk-label">Elemento medible</label>
                                    <input
                                        type="text"
                                        name="measurable_element"
                                        value={formValues.measurable_element}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.measurable_element == "" ? "rk-input--error" : ""}`}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Área/servicio</label>
                                    <select
                                        name="service_area"
                                        className="rk-input"
                                        value={formValues.service_area}
                                        onChange={this.props.onChangeForm}
                                    >
                                        <option value="">Seleccione</option>
                                        <option value="Consultorios">Consultorios</option>
                                        <option value="Servicio de Urgencias">Servicio de Urgencias</option>
                                        <option value="Hospitalización">Hospitalización</option>
                                        <option value="Quirófanos">Quirófanos</option>
                                        <option value="Unidad de Terapia Intensiva">Unidad de Terapia Intensiva</option>
                                        <option value="Tocología">Tocología</option>
                                        <option value="Cuneros">Cuneros</option>
                                        <option value="Unidad de Cuidados Intensivos Neonatales">Unidad de Cuidados Intensivos Neonatales</option>
                                        <option value="Radiología e Imagen">Radiología e Imagen</option>
                                        <option value="Laboratorio Clínico">Laboratorio Clínico</option>
                                        <option value="Banco de Sangre">Banco de Sangre</option>
                                        <option value="Almacén">Almacén</option>
                                        <option value="Cafetería">Cafetería</option>
                                        <option value="CEyE">CEyE</option>
                                        <option value="Central de Enfermería">Central de Enfermería</option>
                                        <option value="Farmacia">Farmacia</option>
                                        <option value="Inhaloterapia">Inhaloterapia</option>
                                        <option value="Unidad de Vigilancia Epidemiológica Hospitalaria (UVEH)">Unidad de Vigilancia Epidemiológica Hospitalaria (UVEH)</option>
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Cláusula ISO</label>
                                    <input
                                        type="text"
                                        name="iso_clause"
                                        value={formValues.iso_clause}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.iso_clause == "" ? "rk-input--error" : ""}`}
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Guía de implementación</label>
                                    <Ckeditor
                                        HandleChange={this.props.HandleChangeInplementionGuide}
                                        formValues={formValues.implementation_guide}
                                        key_text={this.props.key_text}
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Url del video</label>
                                    <input
                                        type="text"
                                        name="video_url"
                                        value={formValues.video_url}
                                        onChange={this.props.onChangeForm}
                                        className="rk-input"
                                        placeholder="Ejemplo: https://www.youtube.com/embed/ApXoWvfEYVU"
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <input
                                        type="hidden"
                                        name="proceso_ids"
                                        value={this.props.selectedOptionProcesos.proceso_ids}
                                    />
                                    <label className="rk-label">Procesos <small className="validate-label">(opcional)</small></label>
                                    <Select
                                        onChange={this.props.handleChangeAutocomplete}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        name="proceso_ids"
                                        defaultValue={this.props.editValuesProcesos}
                                        options={this.props.procesos}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Seleccione"
                                    />
                                </div>
                            </div>

                            {isError && (
                                <div className="col-md-12">
                                    <div className="rk-alert">
                                        <i className="fas fa-exclamation-circle"></i>
                                        Debes de completar todos los campos requeridos
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                            Cerrar
                        </button>
                        <button type="button" className="rk-btn rk-btn--primary" onClick={this.props.submitForm}>
                            <i className="fas fa-check"></i> {this.props.title == "Agregar Numeral" ? "Crear" : "Actualizar"}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default FormCreate;
